import React from "react";
import { buildRoutes } from "@app/routes/RouteBuilder";
import lazyWithRetry from "@shared/utils/lazyWithRetry";

const SecurityDashboard = lazyWithRetry(
  () => import("./ui/pages/SecurityDashboard"),
  "SecurityDashboard",
);

const securityRoutes = buildRoutes([
  {
    path: "/security-dashboard",
    element: SecurityDashboard,
    roles: [1, 5],
  },
]);

export default securityRoutes;
